<template>
  <div class="login">
    <div class="cl-logo">
      <!-- <img src="../../assets/images/cloudlogoimage.png" class="cl-cloudImage"> -->
    </div>
    <div class="cl-suss">
      <div class="login-con" v-show="resultSuccess">
        <img class="successRegister" src="../../assets/images/successRegister.png">
        <h1>Your account has been successfully activated!</h1>
        <el-button class="cl-button" type="primary" @click="login">Log in</el-button>
      </div>
      <div class="login-con" v-show="resultFaild">
        <img class="successRegister" src="../../assets/images/error.png">
        <h1>Your account is not activated!</h1>
        <el-button class="cl-button" disabled type="primary" @click="login">Log in</el-button>
      </div>
    </div>
    <!-- <div class="cl-info"> -->
      <!-- <img src="../../assets/images/clmobile.png" class="cl-telImage"> -->
      <!-- <div class="cl-text">COPYRIGHT © 2020-2025 版权所有：国际海运网 联系地址：辽宁省大连市中山区人民路50号时代广场B座1601</div> -->
    <!-- </div> -->
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'successRegisterEn',
    data() {
      return {
        resultSuccess:'',
        resultFaild:''
      }
    },
    created(){

    },
    mounted() {
      let flag = this.$route.query.flag
      let token = this.$route.query.JSESSIONID
      this.$cookie.set('JSESSIONID', token, 1);
      this.activationResult(flag)
    },
    methods: {
      login() {
        localStorage.setItem('locale', 'en')
        this.$i18n.locale = localStorage.getItem('locale')
        this.$router.push({
          name: "personaloverview"
        })
      },
      activationResult(flag){
        if(flag == '1'){
          this.resultSuccess = true
          this.resultFaild = false
        }else if(flag == '2'){
          this.resultSuccess = false
          this.resultFaild = true
        }
      }
    },
    components: {

    }
  }
</script>

<style lang="scss" scoped>

  .login{
    background-color: rgb(240, 242, 245);
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url("../../assets/images/cloudplatform.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    background-attachment: fixed
  }
  .cl-logo{
    padding-top:30px;
    padding-left:30px;
    width: auto;
  }
  .cl-cloudImage{
    width: auto;
    height: 30px;
  }
  .cl-loginlogo{
    text-align: center;
    margin: 0;
    margin-top: 100px;
  }
  .cl-loginlogo img{
    width: auto;
    height: 55px;
  }
  .cl-info{
    position: absolute;
    bottom: 10px;
    margin-left:2%;
    width: 98%;
  }
  .cl-telImage{
    width: auto;
    height: 35px;
  }
  .cl-text{
    float: right;
    margin-top: 20px;
    margin-right: 20px;
    bottom: 0px;
    font-size: 8px;
    font-family:"微软雅黑";
    color: dimgrey;
  }
  .login-con{
    width: 340px;
    padding: 30px 30px 50px 30px;
    background-color: #fff;
  }
  .cl-suss{
    position: fixed;
    right: 10%;
    top: 18%;
  }
  .cl-button{
    width: 100%;
    margin-top: 40px;
  }
  .loginLogo{
    z-index: 9999;
    overflow: hidden;
    margin-bottom: 20px;
  }
  .loginLogo img{
    float: left;
    width: 70px;
    height: 50px;
    margin-left: 0px;
  }
  .loginLogo span{
    float: left;
    color: #fff;
    margin-left: 25px;
    font-size: 26px;
    margin-top: 14px;
    letter-spacing: 1.6px;
  }
  .successRegister{
    display: block;
    width: 90px;
    height: 90px;
    margin: 20px auto;
  }
  .login-con h1{
    margin-top: 30px;
    font-size: 24px;
    text-align: center;
  }
</style>
